module.exports = __webpack_public_path__ + "media/images/icons/hamburger-9e2df7ab7ae7afe60173bf9aae658348.svg";